import React from 'react';
import sampleImage from "../../Assets/images/Frame 133652.png";
import { BiMoneyWithdraw } from "react-icons/bi";
import { AiFillCalendar } from "react-icons/ai";

import { useNavigate } from 'react-router-dom';
import WelcomeInDashboard from '../../Components/Welcome/WelcomeInDashboard';
import Contact from '../../Components/Contact/Contact';

const AffiliateDashboard = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="container mx-auto mt-32 ">
        <WelcomeInDashboard />

        <div className='flex items-center'>
          {/* Publish Tender Section */}
          <div className="mt-6 md:text-sm text-xs">
            <div className="bg-[#ffffff] md:p-6 p-2  rounded-lg flex flex-wrap md:flex-nowrap justify-center items-center gap-12">
              <div>
                <img src={sampleImage} alt="Sample" className="w-64 h-64" />
              </div>

              <div className="flex-1 ">
                <h2 className="text-xl sm:text-2xl md:text-2xl font-semibold  sm:text-start md:mr-[398px] ">
                  <p className="flex gap-1">
                    <span className="text-[#ff8c00] text-[30px]">
                      <AiFillCalendar />
                    </span>
                    Publish Tender
                  </p>
                </h2>

                <div className=" text-black md:p-4 md:rounded-lg md:inline-block">
                  {/* <ul className="list-disc mt-2 space-y-1 md:ml-5 sm:list-none xs:list-none "> */}
                  <ul className="mt-2 space-y-1 md:ml-5 md:list-disc sm:list-none">
                    <li>We will verify your tender request to publish.</li>
                    <li>
                      Publish your tender in a cost-effective way for only 1000
                      Taka.
                    </li>
                    <li>The tender page needs to be A4-sized to publish.</li>
                    <li>Upload your tender PDF file with seal and signature.</li>
                  </ul>

                  <div className="md:mt-4 mt-2 md:ml-0 ">
                    <button
                      onClick={() => {
                        {
                          navigate('/tenderpublish');
                          window.scrollTo(0, 0);
                        }
                      }}
                      className="bg-[#ff8c00] text-white md:px-6 px-2 py-2 rounded-md "
                    >
                      Request for Tender Publish
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Withdrawal Notice */}
          <div className="mt-6 md:py-4 py-4 md:text-sm text-xs md:p-6 p-2 ">
            <h2 className="text-lg font-semibold flex items-center gap-2">
              <p className="text-[#e42020] text-[30px]">
                <BiMoneyWithdraw />
              </p>
              Withdrawal payment notice
            </h2>
            <ul className="list-disc mt-2 space-y-1">
              <div>1. At least you need to have 100 Taka in your account.</div>

              <div>
                2. You will be able to make your withdrawal after 15 days of
                publish date.
              </div>

              <div>
                3. For withdrawal request, your account needs to be verified.
              </div>
            </ul>
          </div>
        </div>
      </div>
      <Contact />
    </>
  );
};

export default AffiliateDashboard;

